module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/10a6d6ad8a07826fa2cfa3f251619ba2.png";